// App-wide confirmation prompt. Any module can `await confirmStore.confirm({…})`
// to get a boolean; a single <ConfirmHost /> renders the actual dialog.

export type ConfirmOptions = {
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  /** Style the confirm button as destructive (red). */
  danger?: boolean;
};

class ConfirmStore {
  open = $state(false);
  // Kept around during the close transition (overwritten on the next confirm),
  // so the dialog doesn't blank out while animating shut.
  options = $state<ConfirmOptions>({ message: '' });

  #resolve: ((ok: boolean) => void) | null = null;

  // Open the dialog and resolve true (confirm) or false (cancel/dismiss).
  confirm(options: ConfirmOptions): Promise<boolean> {
    // If one is already open, treat it as cancelled before replacing it.
    this.#resolve?.(false);

    this.options = options;
    this.open = true;

    return new Promise<boolean>((resolve) => {
      this.#resolve = resolve;
    });
  }

  #settle(ok: boolean) {
    this.open = false;
    const resolve = this.#resolve;
    this.#resolve = null;
    resolve?.(ok);
  }

  accept() {
    this.#settle(true);
  }

  cancel() {
    this.#settle(false);
  }
}

export const confirmStore = new ConfirmStore();
